module.exports = __webpack_public_path__ + "img/diar-caracteristicas-imagenB-desktop.78d115f7.png";